import { HelpOutlineOutlined } from '@mui/icons-material';
import { Tab, Tabs, Tooltip } from '@mui/material';
import Row from '../../../../components/Row';
import { TabsContainer } from '../../../../components/Tabs';
import { HatMediaType, mediaFilters } from '../../HatMetrics';

export default function HatDbMediaTabs(props: { mediaType: HatMediaType; onChange: (value: HatMediaType) => void }) {
    const tabs = Object.values(HatMediaType).map((mediaType) => {
        const filter = mediaFilters[mediaType];

        let label;
        if (filter.tooltip) {
            label = (
                <Row gap={1} alignItems="center" width="auto">
                    {filter.label}
                    <Tooltip title={filter.tooltip}>
                        <HelpOutlineOutlined color="action" sx={{ fontSize: 16 }} />
                    </Tooltip>
                </Row>
            );
        } else {
            label = filter.label;
        }

        return <Tab key={mediaType} value={mediaType} label={label} />;
    });

    return (
        <TabsContainer sx={{ mt: 2 }}>
            <Tabs
                value={props.mediaType}
                onChange={(_, value) => {
                    props.onChange(value);
                }}
            >
                {tabs}
            </Tabs>
        </TabsContainer>
    );
}
